/**
 * Turns a BadgeUtils navigateString into an admin detail-page path.
 * Colli (and similar) already end with `/detail`; those are returned as-is.
 * Empty navigate strings mean the entity has no admin detail route (display-only).
 */
export function buildAdminDetailPath(navigateString: string | undefined | null): string | undefined {
    if (!navigateString) {
        return undefined;
    }
    if (navigateString.endsWith('/detail')) {
        return navigateString;
    }
    return `${navigateString}/detail`;
}
